export default __webpack_public_path__ + "assets/favicon-96x96.414015f5ccca183a46a89beec5210f68.png";